// extracted by mini-css-extract-plugin
module.exports = {"tabsBox":"Tabs_tabsBox__35Xlm","tabItemBox":"Tabs_tabItemBox__1LTso","tabLabel":"Tabs_tabLabel__1ze2v"};